export default {
    common: {
        home: 'Inicio',
        mainMenu: 'Menú principal',
        inbox: 'Mi bandeja',
        requests: 'Mi Perfil',
        reports: 'Reportes',
        settings: 'Parametrización',
        accesses: 'Accesos',
        flowAdmin: 'Adm Flujo',
        states: 'Estados',
        documents: 'Documentos',
        reviewers: 'Revisores',
        close: 'Cerrar',
        save: 'Guardar',
        edit: 'Editar',
        delete: 'Eliminar',
        detail: 'Detalle',
        actions: 'Acciones',
        status: 'Estado',
        value: 'Valor',
        area: 'Área',
        creatorUser: 'Usuario Creador',
        search: 'Buscar',
        comments: 'Observaciones',
        yes: 'Sí',
        no: 'No',
        loading: 'Cargando...',
        saving: 'Guardando...',
        requiredField: 'El campo es obligatorio',
        requiredOption: 'Selecciona una opción',
        menu1: 'Archivo Personal',
        menu2: 'Planeamiento Organizacional',
        menu3: 'Movimiento de personal',
        menu4: 'Régimen disciplinario',
        menu5: 'Evaluación',
        menu6: 'Salud y bienestar',
        menu7: 'Activos',
        menu8: 'Planilla',
        menu9: 'Gestión académica',
        menu0: 'Funcionarios',
        menu10: 'Mapa',
        menu11: 'Nomina',
    },
    menu: {
        report1: 'Reporte 1',
        report2: 'Reporte 2',
        dashboardReport: 'Reporte Dashboard'
    },
    solicitud: {
        time: 'Tiempo Respuesta',
        title: 'Solicitud Memorando de Acuerdo',
        registerRequest: 'Registrar Solicitud',
        createRequest: 'Crear Solicitud',
        updateRequest: 'Actualizar Solicitud',
        requestDetail: 'Detalle Solicitud',
        generalInfo: 'Información General',
        processInfo: 'Info proceso',
        attachments: 'Adjuntos',
        tracking: 'Seguimiento',
        trackingProcess: 'Seguimiento del proceso',
        trackingList: 'Listado Seguimiento',
        registerComment: 'Registrar Comentario',
        timeline: 'Línea del Tiempo',
        reviewers: 'Revisores',
        titleField: 'Título',
        project: 'Proyecto',
        grant: 'Grant',
        amount: 'Valor',
        object: 'Objeto',
        donor: 'Donante',
        responsible: 'Responsable',
        implementingPartner: 'Socio implementador',
        additionalComments: 'Observaciones/Comentarios Adicionales',
        requestDate: 'Fecha Solicitud',
        recordDate: 'Fecha Registro',
        consecutive: 'Consecutivo',
        creatorArea: 'Creador / Área',
        registerCommentBtn: 'Registrar Comentario',
        saveDraft: 'Guardar borrador',
        draftSaved: 'Borrador guardado correctamente',
        requestSaved: 'Solicitud registrada correctamente',
        commentSaved: 'Comentario/Observación guardado correctamente',
        saveError: 'Error al guardar la solicitud.',
        commentSaveError: 'Error al guardar Comentario/Observación.',
        deleteConfirmTitle: 'Confirmar eliminación',
        deleteConfirmText: '¿Estás seguro de que deseas eliminar este registro?',
        editTooltip: 'Editar',
        detailTooltip: 'Detalle',
        deleteTooltip: 'Eliminar',
        approvedRequest: 'Solicitud aprobada',
        noActionsAvailable: 'No tienes acciones disponibles para este estado.',
        attachAgreement: 'Adjuntar Memorando de Acuerdo',
        observations: 'Observaciones',
        user: 'Usuario',
        from: 'De',
        result: 'Resultado',
        initialState: 'Estado Inicio',
        finalState: 'Estado Fin',
        date: 'Fecha',
        bp: 'BP',
        unitedId: 'ID United Nations',
        validationDate: 'Fecha Validación',
        applicationFrom: 'N° Aplication From',
        agreementNumber: 'N° Agreement',
        policyAttach: 'Adjuntar Póliza',
        receiptAttach: 'Adjuntar Recibo de Pago',
        maAttach: 'Adjuntar MA',
        fields: {
        searchLabel: 'Buscar por Título y/o Consecutivo'
        },
        validations: {
            draftMin: 'Para guardar borrador debes ingresar al menos el título y el valor.',
            attachAgreementRequired: 'Debes adjuntar el Memorando de Acuerdo.',
            actionObservationRequired: 'Debes ingresar observaciones para esta acción.',
            bpUnitedDateRequired: 'Debes ingresar BP, ID United Nations y Fecha Validación para aprobar.',
            bpSignetRequired: 'Debes asignar la solicitud para continuar.',
            returnObservationRequired: 'Debes ingresar observaciones para devolver.',
            returnFieldsEmpty: 'Para devolver, BP / ID United Nations / Fecha Validación deben estar vacíos.',
            applicationFromRequired: 'Debes ingresar el N° Aplication From.',
            datesRequired: 'Debes ingresar la fecha inicio, fecha fin y # de memorando.',
            agreementRequired: 'Debes ingresar el N° Agreement.',
            stateApprovedNeedBp: 'El BP es obligatorio cuando la solicitud está aprobada',
            stateApprovedNeedUnited: 'El ID United Nations es obligatorio cuando la solicitud está aprobada',
            stateApprovedNeedDate: 'La Fecha Validación es obligatoria cuando la solicitud está aprobada',
            requiredPolicy: 'La Póliza es obligatoria',
            requiredReceipt: 'El Recibo de Pago es obligatorio',
            requiredMA: 'El MA es obligatorio'
        },
        actions: {
            approve: 'Aprobar',
            send: 'Enviar',
            create: 'Crear',
            finish: 'Finalizar',
            liquidate: 'Liquidar',
            return: 'Devolver',
            reject: 'Rechazar',
            cancel: 'Cancelar'
        },
        results: {
        canceled: 'Cancelado',
        request: 'Solicitud',
        received: 'Recibido',
        comment: 'Comentario',
        finished: 'Finalizado',
        returned: 'Devuelto',
        code: 'Código'
        },
        excelHeaders: {
        actions: 'Acciones',
        status: 'Estado',
        consecutive: 'Consecutivo',
        title: 'Título',
        requestDate: 'Fecha Solicitud',
        value: 'Valor',
        grant: 'Grant',
        area: 'Área',
        creatorUser: 'Usuario Creador'
        }
    }
}